import { Component, OnInit, Inject } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { CompanyInfo } from '../model/company.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { ProjectInfo } from '../model/project.model';
import { LookupInfo } from '../model/lookup.model';
import { AssetGroupInfo } from '../model/AssetGroupInfo.model';
import { AssetCategoryInfoInfo } from '../model/AssetCategoryInfoInfo.model';
import { AssetTypeInfo } from '../model/AssetTypeInfo.model';
import { AssetPortfolioInfo } from '../model/AssetPortfolioInfo.model';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-asset-management',
  templateUrl: './asset-management.component.html',
  styleUrls: ['./asset-management.component.css']
})
export class AssetManagementComponent implements OnInit {
  form: FormGroup;
  formAssetPortfolio: FormGroup;
  formAssetGroup: FormGroup;
  formAssetCategory: FormGroup;
  formAssetType: FormGroup;
  public body: string;
  _EmpCode: string;
  _RoleCode: string;
  CompanyListPromise: Promise<CompanyInfo[]>
  CompanyList: CompanyInfo[] = [];
  CompanyListPromisereturn: Promise<CompanyInfo[]>[]
  IndustryList: LookupInfo[]
  CustomerTypeList: LookupInfo[]
  sortOrderCompany: any = 'asc'
  
  AssetGroupListPromise: Promise<AssetGroupInfo[]>
  AssetGroupList: AssetGroupInfo[] = [];
  AssetGroupListPromisereturn: Promise<AssetGroupInfo[]>[]
  totalItems: number = 0
  assetGroupCodeSend: string = '';

  AssetCategoryList: AssetCategoryInfoInfo[] = [];
  AssetTypeList: AssetTypeInfo[] = []
  
  txtSearchAssetTypeCode: string;
  txtSearchAssetTypeName: string;

  AssetGroupLisNoPaging: AssetGroupInfo[] = [];
  AssetPortfolioList: AssetPortfolioInfo[] = [];
  totalPagesAssetPortfolio: number = 0
  
  txtSearchCompanyName: string
  ddlSearchCustomerType: number | null = null
  noResultString: any //set value to this on search click, in case of one search field
  
  txtCompanyGroupName: string
  txtCompanyGroupDesc: string
  hidAssetPortfolioID: number
  hidAssetGroupID: number
  hidAssetCategoryID: number
  hidAssetTypeID: number
  
  flagduplicate: boolean;
  IsDuplicateCode: boolean;
  hidCompanyId: number
  
  public currentPageNumber: number = 1
  public currentPageNumberAssetGroup: number = 1
  public currentPageNumberAssetCategory: number = 1
  public currentPageNumberAssetPortfolio: number = 1
  public AssetTotal: number
  public AssetGroupTotal: number
  public totalPages: number
  public totalPagesAssetGroup: number
  public totalPagesAssetCategory: number
  public environment: number
  
  ProjectTotal: any
  isOnUpdate: boolean;
  isOnUpdateAssetPortfolio: boolean;
  isOnUpdateAssetGroup: boolean;
  isOnUpdateAssetCategory: boolean;
  isOnUpdateAssetType: boolean;
  isSubmitted: any;
  
  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;
  
  getreturn: Promise<string>;
  
  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';
  loading: boolean = false;
  
  //Modal
  titlemodal: string;
  detailmodal: string;
  /************************* End Variables ************************** */
  
  // Hide Show Asset Section Variable
  isVisible: boolean = false;
  isAssetGroupVisible: boolean = false;
  isAssetCategoryVisible: boolean = false;
  isAssetTypeVisible: boolean = false;
  AssetPortfolioCodeSelected: string = '';
  AssetPortfolioNameSelected: string = '';
  AssetGroupNameSelected: string = '';
  AssetGroupCodeSelected: string = '';
  AssetCategoryCodeSelected: string = '';
  AssetCategoryNameSelected: string = '';
  isReadOnly: boolean = true;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private TokenService: TokenService, private GlobalService: GlobalService) { 
    this.baseurl = environment.base_api;
  }

  async ngOnInit(): Promise<void> {
    this._EmpCode = localStorage.getItem("EmpCode");
    this._RoleCode = localStorage.getItem("EmpRoleCode");

    // this.formAssetPortfolio = this.formBuilder.group({
    //   AssetPortfolioCode: [null, [Validators.required,
    //   this.assetPortfolioCodeUniqueValidator()
    //   ]
    // ],
    //   AssetPortfolioName: [null, Validators.required],
    //   AssetPortfolioDesc: [null]
    // });

    this.formAssetPortfolio = this.formBuilder.group({
      AssetPortfolioCode: [null],
      AssetPortfolioName: [null, Validators.required],
      AssetPortfolioDesc: [null]
    });

    this.formAssetGroup = this.formBuilder.group({
      txtAssetGroupName: [null, Validators.required],
      txtCompanyGroupDesc: [null]
    });

    this.formAssetCategory = this.formBuilder.group({
      txtAssetCategoryName: [null, Validators.required],
      txtCompanyCategoryDesc: [null]
    });

    this.formAssetType = this.formBuilder.group({
      txtAssetTypeName: [null, Validators.required],
      txtAssetTypeDesc: [null]
    });

    await this.LoadAssetPortfolioList();
    //await this.loadAssetGroup();
  }

  async loadAssetGroup(viewfromassetportfolio: string | null = null, assetPortfolioCode: string | null = null) {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      console.log('currentPageNumberAssetGroup', this.currentPageNumberAssetGroup);
      console.log('environment.PageSizeSmall', environment.PageSizeSmall);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (viewfromassetportfolio === "Y") {
        this.currentPageNumberAssetGroup = 1; // Reset to page 1 when viewing from asset group
      }

      const objectjson = {
        AssetPortfolioCode: assetPortfolioCode,
        rowFetch: environment.PageSizeSmall,
        rowOFFSet: ((this.currentPageNumberAssetGroup - 1) < 0 ? 0 : (this.currentPageNumberAssetGroup - 1)) * environment.PageSizeSmall
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "AssetType/GetAssetGroup",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.AssetGroupList = response;
      this.totalItems = this.AssetGroupList.length;

      if (this.AssetGroupList.length <= 0) {
        this.currentPageNumberAssetGroup = 0;
      } else {
        if (this.currentPageNumberAssetGroup == 0) this.currentPageNumberAssetGroup = 1;
        this.totalItems = Number(this.AssetGroupList[0].itemTotal);
      }

      this.totalPagesAssetGroup = Math.ceil(this.totalItems / environment.PageSizeSmall);
    } catch (error) {
      console.error('Error loading company group:', error);
      alert('An error occurred while loading company group data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  OnLoadAssetGroupList(target = null) {

  console.log('Callback target:', target);

    if (target != null) {
      this.currentPageNumberAssetGroup = target.currentPageNumber;
      this.totalPagesAssetGroup = target.totalPages;
    }

    this.loadAssetGroup();
  }

  btnClick_onCreateAssetGroup() {
    this.isOnUpdateAssetGroup = false;

    this.formAssetGroup.setValue({
    txtAssetGroupName: '',
    txtCompanyGroupDesc: ''
  });

  this.formAssetGroup.markAsPristine();
  this.formAssetGroup.markAsUntouched();
  this.formAssetGroup.updateValueAndValidity();

    $('#ModalAssetGroup').modal('show');
  }

  async loadAssetCategory(viewfromassetgroup: string | null = null, assetGroupCode: string | null = null) {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      console.log('currentPageNumberAssetCategory', this.currentPageNumberAssetCategory);
      console.log('environment.PageSizeSmall', environment.PageSizeSmall);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (viewfromassetgroup === "Y") {
        this.currentPageNumberAssetCategory = 1; // Reset to page 1 when viewing from asset group
      }

      const objectjson = {
        AssetGroupCode: assetGroupCode,
        rowFetch: environment.PageSizeSmall,
        rowOFFSet: ((this.currentPageNumberAssetCategory - 1) < 0 ? 0 : (this.currentPageNumberAssetCategory - 1)) * environment.PageSizeSmall
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "AssetType/GetAssetCategory",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.AssetCategoryList = response;
      this.totalItems = this.AssetCategoryList.length;

      if (this.AssetCategoryList.length <= 0) {
        this.currentPageNumberAssetCategory = 0;
      } else {
        if (this.currentPageNumberAssetCategory == 0) this.currentPageNumberAssetCategory = 1;
        this.totalItems = Number(this.AssetCategoryList[0].itemTotal);
      }

      this.totalPagesAssetCategory = Math.ceil(this.totalItems / environment.PageSizeSmall);
    } catch (error) {
      console.error('Error loading company group:', error);
      alert('An error occurred while loading company group data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  OnLoadAssetCategoryList(target = null) {
    console.log('Callback target:', target);

    if (target != null) {
      this.currentPageNumberAssetCategory = target.currentPageNumber;
      this.totalPagesAssetCategory = target.totalPages;
    }

    this.loadAssetCategory("", this.AssetGroupCodeSelected);
  }

  async loadAssetType(viewfromassetType: string | null = null, assetCategoryCode: string | null = null) {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      console.log('currentPageNumber', this.currentPageNumber);
      console.log('environment.PageSize', environment.PageSize);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (viewfromassetType === "Y") {
        this.currentPageNumber = 1; // Reset to page 1 when viewing from asset group
      }

      const objectjson = {
        AssetCategoryCode: assetCategoryCode, // Default need to send search object

        AssetTypeCode: this.checkUndefinedString(this.txtSearchAssetTypeCode?.trim()),
        AssetTypeName: this.checkUndefinedString(this.txtSearchAssetTypeName?.trim()),

        rowFetch: environment.PageSize,
        rowOFFSet: ((this.currentPageNumber - 1) < 0 ? 0 : (this.currentPageNumber - 1)) * environment.PageSize
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "AssetType/GetAssetType",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.AssetTypeList = response;

      console.log('this.AssetTypeList', response)
      console.log('this.AssetTypeList', this.AssetTypeList)

      this.totalItems = this.AssetTypeList.length;

      if (this.AssetTypeList.length <= 0) {
        this.currentPageNumber = 0;
      } else {
        if (this.currentPageNumber == 0) this.currentPageNumber = 1;
        this.totalItems = Number(this.AssetTypeList[0].itemTotal);
      }

      this.totalPages = Math.ceil(this.totalItems / environment.PageSize);
    } catch (error) {
      console.error('Error loading asset type:', error);
      alert('An error occurred while loading asset type data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  OnLoadAssetTypeList(target = null) {
    console.log('Callback target:', target);

    if (target != null) {
      this.currentPageNumber = target.currentPageNumber;
      this.totalPages = target.totalPages;
    }

    this.loadAssetType("", this.AssetCategoryCodeSelected);
  }

  btnClick_SearchAssetTypeList() {
    this.loadAssetType("Y", this.AssetCategoryCodeSelected);
  }

  ClearAssetTypeSearch() {
    this.txtSearchAssetTypeCode = "";
    this.txtSearchAssetTypeName = "";
    this.loadAssetType("Y", this.AssetCategoryCodeSelected);
  }

  async btnClick_submitInsertAssetGroup() {
    if (this.formAssetGroup.valid) {
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            console.log('form submitted');
            //this.OnCreating('y');
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
              })
            };
    
            var objectjson = {};
            objectjson['AssetPortfolioCode'] = this.checkUndefinedString(this.AssetPortfolioCodeSelected);
            objectjson['AssetGroupName'] = this.checkUndefinedString(this.formAssetGroup.get('txtAssetGroupName')?.value);
            objectjson['AssetGroupDesc'] = this.checkUndefinedString(this.formAssetGroup.get('txtCompanyGroupDesc')?.value);
            objectjson['AssetGroupCreateBy'] = this.checkUndefinedString(this._EmpCode);
    
            let strjson = JSON.stringify(objectjson);
    
            this.isSubmitted = this.httpClient.post<AssetGroupInfo[]>(this.baseurl + "AssetType/InsertAssetGroup", strjson, httpOptions)
    
              .subscribe(result => this.isSubmitted = result, failCb => {
                console.log("Insert fail")
                //this.OnCreating('n');            
              },
                () => {
                  console.log("Insert = " + this.isSubmitted)
                  $('#ModalAssetGroup').modal('hide');
                  $('#ModalCreateCompGroupComplete').modal();
                  this.loadAssetGroup("Y", this.AssetPortfolioCodeSelected);
                }
              )
          }
    
        } else {
          this.validateAllFormFields(this.formAssetGroup);
        }
  }

  btnClick_onUpdateAssetGroup(id) {
    $('#ModalAssetGroup').modal('hide');
    this.isOnUpdateAssetGroup = true
    console.log("btnClick_onUpdateCompanyGroup id = " + id);

    let index = this.AssetGroupList.findIndex(x => x.AssetGroupID == id);

    this.formAssetGroup.patchValue({
      txtAssetGroupName: this.AssetGroupList[index].AssetGroupName != null ? this.AssetGroupList[index].AssetGroupName : null,
      txtCompanyGroupDesc: this.AssetGroupList[index].AssetGroupDesc != null ? this.AssetGroupList[index].AssetGroupDesc : null
    });

    this.hidAssetGroupID = this.AssetGroupList[index].AssetGroupID

    $('#ModalAssetGroup').modal();

  }

  async btnClick_submitUpdateAssetGroup(id) {
    if (this.formAssetGroup.valid) {
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            //this.OnUpdating('y');
    
            id = this.hidAssetGroupID
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
    
              })
            };
    
            var objectjson = {};
            objectjson['AssetGroupID'] = id;
            objectjson['AssetGroupName'] = this.checkUndefinedString(this.formAssetGroup.get('txtAssetGroupName')?.value);
            objectjson['AssetGroupDesc'] = this.checkUndefinedString(this.formAssetGroup.get('txtCompanyGroupDesc')?.value);
            objectjson['AssetGroupUpdateBy'] = this.checkUndefinedString(this._EmpCode);
    
            let strjson = JSON.stringify(objectjson);
    
            this.isSubmitted = this.httpClient.post<AssetGroupInfo[]>(this.baseurl + "AssetType/UpdateAssetGroup", strjson, httpOptions)
    
              .subscribe(result => this.isSubmitted = result, failCb => {
                console.log("Update fail");
                //this.OnUpdating('n');
              },
                () => {
                  console.log("Update = " + this.isSubmitted);
                  //this.OnUpdating('n');
                  $('#ModalAssetGroup').modal('hide');
                  $('#ModalUpdateCompGroupComplete').modal();
                  this.loadAssetGroup("Y", this.AssetPortfolioCodeSelected);
                }
              )
          }
        } else {
          this.validateAllFormFields(this.form);
        }
  }

  chkallAssetGroupclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxassetGroup"]').prop('checked', check);
  }

  async btnClick_onDeleteAssetGroupList() {
    const checkedAssetGroup = $('[name="checkboxassetGroup"]:checked');
    const num = checkedAssetGroup.length;
    if (num === 0) {
      alert("กรุณาเลือกอย่างน้อย 1 รายการในการลบ");
    return;
  }

    if (confirm("ยืนยันว่าต้องการลบรายการ Asset Group?")) {
    
          var checkkedassetgroup = $('[name="checkboxassetGroup"]:checked');
          let num = checkkedassetgroup.length;
          let listAssetGroupModel = [];
          
    
          for (var i = 0; i < num; i++) {
            var AssetGroupcurrent = <HTMLInputElement>checkkedassetgroup[i];
            let AssetgroupInfo = new AssetGroupInfo;
            AssetgroupInfo.AssetGroupID = parseInt(AssetGroupcurrent.value);
    
              var currentAssetGroup = this.AssetGroupList.filter(x => { return x.AssetGroupID == AssetgroupInfo.AssetGroupID });
              var isOwner = (currentAssetGroup[0].AssetGroupCreateBy == this._EmpCode);
    
              console.log(" Delete id = " + AssetgroupInfo.AssetGroupID + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
              if (isOwner || (this._RoleCode != "")) {
                listAssetGroupModel.push(AssetgroupInfo);
              } else
              {
                //this.titlemodal = ""
                //this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
                this.detailmodal = "You don't have permission to delete this company. Please contact" + currentAssetGroup[0].AssetGroupCreateBy;
                $('#ModalError .modal-header').text("Information");
                $('#ModalError .modal-header').addClass('bg-blue');
                $('#ModalError').modal();
    
                listAssetGroupModel = [];
                break; //break loop
              }
          }
    
          if (listAssetGroupModel.length > 0) {
            this.deleteListAssetGroup(listAssetGroupModel)
          }
    
        }
  }

  async deleteListAssetGroup(listCompanyGroupModel) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        //Send to delete
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
       
  
        let strjsonCompGroupInfo = JSON.stringify(listCompanyGroupModel);
  
        this.httpClient.post<AssetGroupInfo[]>(this.baseurl + "AssetType/DeleteListAssetGroup", strjsonCompGroupInfo, httpOptions)
          .toPromise()
          .then(data => {
            console.log("delete asset group list successfully");
            $('#ModalDeleteCompGroupComplete').modal('show');
            this.loadAssetGroup("Y", this.AssetPortfolioCodeSelected);
          })
          .catch(err => {
            console.log(err);
          });
      }
  }

  async btnClick_viewAssetinGroup(AssetGroupCode: string, AssetGroupName: string) {   
     // Show asset category section
    this.AssetGroupCodeSelected = AssetGroupCode;
    this.AssetGroupNameSelected = AssetGroupName;

    const viewfromassetgroup = "Y";

    this.isAssetCategoryVisible = true;
    await this.loadAssetCategory(viewfromassetgroup, AssetGroupCode);
  }
  
  btnClick_onCreateAssetCategory() {
    this.isOnUpdateAssetCategory = false;

    this.formAssetCategory.setValue({
    txtAssetCategoryName: '',
    txtCompanyCategoryDesc: ''
  });

  this.formAssetCategory.markAsPristine();
  this.formAssetCategory.markAsUntouched();
  this.formAssetCategory.updateValueAndValidity();

    $('#ModalAssetCategory').modal('show');
  }

  async btnClick_submitInsertAssetCategory() {
    if (this.formAssetCategory.valid) {
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            console.log('form submitted');
            //this.OnCreating('y');
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
              })
            };
    
            var objectjson = {};
            objectjson['AssetGroupCode'] = this.checkUndefinedString(this.AssetGroupCodeSelected);
            objectjson['AssetCategoryName'] = this.checkUndefinedString(this.formAssetCategory.get('txtAssetCategoryName')?.value);
            objectjson['AssetCategoryDesc'] = this.checkUndefinedString(this.formAssetCategory.get('txtCompanyCategoryDesc')?.value);
            objectjson['AssetCategoryCreateBy'] = this.checkUndefinedString(this._EmpCode);
    
            console.log('objectjson for insert AssetCategory', objectjson);

            let strjson = JSON.stringify(objectjson);
    
            this.isSubmitted = this.httpClient.post<AssetCategoryInfoInfo[]>(this.baseurl + "AssetType/InsertAssetCategory", strjson, httpOptions)
    
              .subscribe(result => this.isSubmitted = result, failCb => {
                console.log("Insert fail")
                //this.OnCreating('n');            
              },
                () => {
                  console.log("Insert = " + this.isSubmitted)
                  $('#ModalAssetCategory').modal('hide');
                  $('#ModalCreateAssetCategoryComplate').modal();
                  this.loadAssetCategory("Y", this.AssetGroupCodeSelected);
                }
              )
          }
    
        } else {
          this.validateAllFormFields(this.formAssetCategory);
        }
  }

  btnClick_onUpdateAssetCategory(id) {
    $('#ModalAssetCategory').modal('hide');
    this.isOnUpdateAssetCategory = true
    console.log("btnClick_onUpdateAssetCategory id = " + id);

    let index = this.AssetCategoryList.findIndex(x => x.AssetCategoryID == id);

    this.formAssetCategory.patchValue({
      txtAssetCategoryName: this.AssetCategoryList[index].AssetCategoryName != null ? this.AssetCategoryList[index].AssetCategoryName : null,
      txtCompanyCategoryDesc: this.AssetCategoryList[index].AssetCategoryDesc != null ? this.AssetCategoryList[index].AssetCategoryDesc : null
    });

    this.hidAssetCategoryID = this.AssetCategoryList[index].AssetCategoryID

    $('#ModalAssetCategory').modal();

  }

  async btnClick_submitUpdateAssetCategory(id) {

    console.log("id: ", id);

    if (this.formAssetCategory.valid) {
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            //this.OnUpdating('y');
    
            id = this.hidAssetCategoryID;
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
    
              })
            };
    
            var objectjson = {};
            objectjson['AssetCategoryID'] = id;
            objectjson['AssetCategoryName'] = this.checkUndefinedString(this.formAssetCategory.get('txtAssetCategoryName')?.value);
            objectjson['AssetCategoryDesc'] = this.checkUndefinedString(this.formAssetCategory.get('txtCompanyCategoryDesc')?.value);
            objectjson['AssetCategoryUpdateBy'] = this.checkUndefinedString(this._EmpCode);
    
            let strjson = JSON.stringify(objectjson);
    
            this.isSubmitted = this.httpClient.post<AssetGroupInfo[]>(this.baseurl + "AssetType/UpdateAssetCategory", strjson, httpOptions)
    
              .subscribe(result => this.isSubmitted = result, failCb => {
                console.log("Update fail");
                //this.OnUpdating('n');
              },
                () => {
                  console.log("Update = " + this.isSubmitted);
                  //this.OnUpdating('n');
                  $('#ModalAssetCategory').modal('hide');
                  $('#ModalUpdateAssetCategoryComplete').modal();
                  this.loadAssetCategory("Y", this.AssetGroupCodeSelected);
                }
              )
          }
        } else {
          this.validateAllFormFields(this.form);
        }
  }

  chkallAssetCategoryclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxassetCategory"]').prop('checked', check);
  }

  async btnClick_onDeleteAssetCategoryList() {
    const checkedAssetCategory = $('[name="checkboxassetCategory"]:checked');
  const num = checkedAssetCategory.length;

  if (num === 0) {
    alert("กรุณาเลือกอย่างน้อย 1 รายการในการลบ");
    return;
  }

  if (confirm("ยืนยันว่าต้องการลบรายการ Asset Category?")) {
    let listAssetCategoryModel: AssetCategoryInfoInfo[] = [];

    for (let i = 0; i < num; i++) {
      const AssetCategorycurrent = <HTMLInputElement>checkedAssetCategory[i];
      const AssetCategoryInfo = new AssetCategoryInfoInfo(); 

      AssetCategoryInfo.AssetCategoryID = parseInt(AssetCategorycurrent.value);

      const currentAssetCategory = this.AssetCategoryList.filter(
        x => x.AssetCategoryID === AssetCategoryInfo.AssetCategoryID
      );

      const isOwner = currentAssetCategory[0].AssetCategoryCreateBy === this._EmpCode;

      console.log("Delete id = " + AssetCategoryInfo.AssetCategoryID + 
                  "\n Role = " + this._RoleCode + 
                  "\n Is Owner? = " + isOwner);

      if (isOwner || this._RoleCode !== "") {
        listAssetCategoryModel.push(AssetCategoryInfo);
      } else {
        this.detailmodal = "You don't have permission to delete this category. Please contact " + currentAssetCategory[0].AssetCategoryCreateBy;
        $('#ModalError .modal-header').text("Information");
        $('#ModalError .modal-header').addClass('bg-blue');
        $('#ModalError').modal();

        listAssetCategoryModel = [];
        break; // ❗ หยุด loop ถ้าเจอสิทธิ์ไม่พอ
      }
    }

    if (listAssetCategoryModel.length > 0) {
      this.deleteListAssetCategory(listAssetCategoryModel);
    }
  }
  }

  async deleteListAssetCategory(listCompanyGroupModel) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        //Send to delete
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
       
  
        let strjsonCompGroupInfo = JSON.stringify(listCompanyGroupModel);
  
        this.httpClient.post<AssetCategoryInfoInfo[]>(this.baseurl + "AssetType/DeleteListAssetCategory", strjsonCompGroupInfo, httpOptions)
          .toPromise()
          .then(data => {
            console.log("delete asset category list successfully");
            $('#ModalDeleteAssetCategoryComplete').modal('show');
            this.loadAssetCategory("Y", this.AssetGroupCodeSelected);
          })
          .catch(err => {
            console.log(err);
          });
      }
  }

  async btnClick_viewAssetTypeinCategory(AssetCategoryCode: string, AssetCategoryName: string) {   
     // Show asset category section
    this.AssetCategoryCodeSelected = AssetCategoryCode;
    this.AssetCategoryNameSelected = AssetCategoryName;

    const viewfromassetcategory = "Y";

    this.isAssetTypeVisible = true;
    await this.loadAssetType(viewfromassetcategory, this.AssetCategoryCodeSelected);
  }

  btnClick_onCreateAssetType() {
    this.isOnUpdateAssetType = false;

    this.formAssetType.setValue({
    txtAssetTypeName: '',
    txtAssetTypeDesc: ''
  });

  this.formAssetType.markAsPristine();
  this.formAssetType.markAsUntouched();
  this.formAssetType.updateValueAndValidity();

    $('#ModalAssetType').modal('show');
  }

  async btnClick_submitInsertAssetType() {
    if (this.formAssetType.valid) {
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            console.log('form submitted');
            //this.OnCreating('y');
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
              })
            };
    
            var objectjson = {};
            objectjson['AssetGroupCode'] = this.checkUndefinedString(this.AssetGroupCodeSelected);
            objectjson['AssetCategoryCode'] = this.checkUndefinedString(this.AssetCategoryCodeSelected);
            objectjson['AssetTypeName'] = this.formAssetType.get('txtAssetTypeName')?.value;
            objectjson['AssetTypeDesc'] = this.formAssetType.get('txtAssetTypeDesc')?.value;
            objectjson['AssetTypeCreateBy'] = this.checkUndefinedString(this._EmpCode);
    
            console.log('objectjson for insert AssetCategory', objectjson);

            let strjson = JSON.stringify(objectjson);
    
            this.isSubmitted = this.httpClient.post<AssetCategoryInfoInfo[]>(this.baseurl + "AssetType/InsertAssetType", strjson, httpOptions)
    
              .subscribe(result => this.isSubmitted = result, failCb => {
                console.log("Insert fail")
                //this.OnCreating('n');            
              },
                () => {
                  console.log("Insert = " + this.isSubmitted)
                  this.formAssetType.reset();
                  $('#ModalAssetType').modal('hide');
                  $('#ModalCreateAssetTypeComplete').modal();
                  this.loadAssetType("Y", this.AssetCategoryCodeSelected);
                }
              )
          }
    
        } else {
          this.validateAllFormFields(this.formAssetCategory);
        }
  }

  btnClick_onUpdateAssetType(id) {
    $('#ModalAssetType').modal('hide');
    this.isOnUpdateAssetType = true
    console.log("btnClick_onUpdateAssetType id = " + id);

    let index = this.AssetTypeList.findIndex(x => x.AssetTypeID == id);

    this.formAssetType.patchValue({
      txtAssetTypeName: this.AssetTypeList[index].AssetTypeName != null ? this.AssetTypeList[index].AssetTypeName : null,
      txtAssetTypeDesc: this.AssetTypeList[index].AssetTypeDesc != null ? this.AssetTypeList[index].AssetTypeDesc : null
    });

    this.hidAssetTypeID = this.AssetTypeList[index].AssetTypeID

    $('#ModalAssetType').modal();

  }

  async btnClick_submitUpdateAssetType(id) {
    //console.log("id: ", id);

    if (this.formAssetType.valid) {
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            //this.OnUpdating('y');
    
            id = this.hidAssetTypeID;
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
    
              })
            };
    
            var objectjson = {};
            objectjson['AssetTypeID'] = id;
            objectjson['AssetTypeName'] = this.checkUndefinedString(this.formAssetType.get('txtAssetTypeName')?.value);
            objectjson['AssetTypeDesc'] = this.checkUndefinedString(this.formAssetType.get('txtAssetTypeDesc')?.value);
            objectjson['AssetTypeUpdateBy'] = this.checkUndefinedString(this._EmpCode);
    
            let strjson = JSON.stringify(objectjson);
    
            this.isSubmitted = this.httpClient.post<AssetGroupInfo[]>(this.baseurl + "AssetType/UpdateAssetType", strjson, httpOptions)
    
              .subscribe(result => this.isSubmitted = result, failCb => {
                console.log("Update fail");
                //this.OnUpdating('n');
              },
                () => {
                  console.log("Update = " + this.isSubmitted);
                  //this.OnUpdating('n');
                  $('#ModalAssetType').modal('hide');
                  $('#ModalUpdateAssetTypeComplete').modal();
                  this.loadAssetType("Y", this.AssetCategoryCodeSelected);
                }
              )
          }
        } else {
          this.validateAllFormFields(this.form);
        }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  chkallAssetTypeclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxAssetType"]').prop('checked', check);
  }

  async btnClick_onDeleteAssetTypeList() {
    const checkedAssetType = $('[name="checkboxAssetType"]:checked');
    const num = checkedAssetType.length;

  if (num === 0) {
    alert("กรุณาเลือกอย่างน้อย 1 รายการในการลบ");
    return;
  }

  if (confirm("ยืนยันว่าต้องการลบรายการ Asset Category?")) {
    let listAssetTypeModel: AssetTypeInfo[] = [];

    for (let i = 0; i < num; i++) {
      const AssetTypecurrent = <HTMLInputElement>checkedAssetType[i];
      const assetTypeInfo = new AssetTypeInfo();

      assetTypeInfo.AssetTypeID = parseInt(AssetTypecurrent.value);

      const currentAssetType = this.AssetTypeList.filter(
        x => x.AssetTypeID === assetTypeInfo.AssetTypeID
      );

      const isOwner = currentAssetType[0].AssetTypeCreateBy === this._EmpCode;

      console.log("Delete id = " + assetTypeInfo.AssetTypeID + 
                  "\n Role = " + this._RoleCode + 
                  "\n Is Owner? = " + isOwner);

      if (isOwner || this._RoleCode !== "") {
        listAssetTypeModel.push(assetTypeInfo);
      } else {
        this.detailmodal = "You don't have permission to delete this category. Please contact " + currentAssetType[0].AssetTypeCreateBy;
        $('#ModalError .modal-header').text("Information");
        $('#ModalError .modal-header').addClass('bg-blue');
        $('#ModalError').modal();

        listAssetTypeModel = [];
        break; // ❗ หยุด loop ถ้าเจอสิทธิ์ไม่พอ
      }
    }

    if (listAssetTypeModel.length > 0) {
      this.deleteListAssetType(listAssetTypeModel);
    }
  }
  }

  async deleteListAssetType(listAssetTypeModel) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        //Send to delete
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
       
  
        let strjsonCompGroupInfo = JSON.stringify(listAssetTypeModel);
  
        this.httpClient.post<AssetTypeInfo[]>(this.baseurl + "AssetType/DeleteListAssetTypeList", strjsonCompGroupInfo, httpOptions)
          .toPromise()
          .then(data => {
            console.log("delete asset type list successfully");
            $('#ModalDeleteAssetTypeComplete').modal('show');
            this.loadAssetType("Y", this.AssetCategoryCodeSelected);
          })
          .catch(err => {
            console.log(err);
          });
      }
  }


  isFieldAssetGroupValid(field: string) {
    return !this.formAssetGroup.get(field).valid && this.formAssetGroup.get(field).touched;
  }

  isFieldAssetCategoryValid(field: string) {
    return !this.formAssetCategory.get(field).valid && this.formAssetCategory.get(field).touched;
  }

  isFieldAssetTypeValid(field: string) {
    return !this.formAssetType.get(field).valid && this.formAssetType.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      }
    });

    this.formAssetGroup.reset();
  }

  displayAssetGroupFieldCss(field: string) {
    return {
      'has-error': this.isFieldAssetGroupValid(field),
      'has-feedback': this.isFieldAssetGroupValid(field)
    };
  }

  displayAssetCategoryFieldCss(field: string) {
    return {
      'has-error': this.isFieldAssetCategoryValid(field),
      'has-feedback': this.isFieldAssetCategoryValid(field)
    };
  }
  
  displayAssetTypeFieldCss(field: string) {
    return {
      'has-error': this.isFieldAssetTypeValid(field),
      'has-feedback': this.isFieldAssetTypeValid(field)
    };
  }

  async LoadAssetPortfolioList() {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      console.log('currentPageNumberAssetPortfolio', this.currentPageNumberAssetPortfolio);
      console.log('environment.PageSizeSmall', environment.PageSizeSmall);

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        //CompanyGroupCode: this.CompanyGroupCode,
        rowFetch: environment.PageSizeSmall,
        rowOFFSet: ((this.currentPageNumberAssetPortfolio - 1) < 0 ? 0 : (this.currentPageNumberAssetPortfolio - 1)) * environment.PageSizeSmall
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "AssetType/GetAssetPortfolio",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.AssetPortfolioList = response;
      this.totalItems = this.AssetPortfolioList.length;

      if (this.AssetPortfolioList.length <= 0) {
        this.currentPageNumberAssetPortfolio = 0;
      } else {
        if (this.currentPageNumberAssetPortfolio == 0) this.currentPageNumberAssetPortfolio = 1;
        this.totalItems = Number(this.AssetPortfolioList[0].itemTotal);
      }

      this.totalPagesAssetPortfolio = Math.ceil(this.totalItems / environment.PageSizeSmall);
    } catch (error) {
      console.error('Error loading asset portfolio:', error);
      alert('An error occurred while loading asset portfolio data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  OnLoadAssetPortfolioList(target = null) {

  console.log('Callback target:', target);

    if (target != null) {
      this.currentPageNumberAssetPortfolio = target.currentPageNumber;
      this.totalPagesAssetPortfolio = target.totalPages;
    }

    this.LoadAssetPortfolioList();
  }

  isFieldAssetPortfolioValid(field: string) {
    return !this.formAssetPortfolio.get(field).valid && this.formAssetPortfolio.get(field).touched;
  }

  displayAssetPortfolioFieldCss(field: string) {
    return {
      'has-error': this.isFieldAssetPortfolioValid(field),
      'has-feedback': this.isFieldAssetPortfolioValid(field)
    };
  }
  
  btnClick_onCreateAssetPortfolio() {
    console.log('pass validate!!');
    this.isOnUpdateAssetPortfolio = false;

    this.formAssetPortfolio.setValue({
    AssetPortfolioCode: null,
    AssetPortfolioName: '',
    AssetPortfolioDesc: ''
  });

  console.log('before pass validate!!');

  this.formAssetPortfolio.markAsPristine();
  this.formAssetPortfolio.markAsUntouched();
  this.formAssetPortfolio.updateValueAndValidity();

  console.log('pass validate!!');

    $('#ModalAssetPortfolio').modal('show');
  }

  assetPortfolioCodeUniqueValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value || !this.AssetPortfolioList) {
        return null;
      }
      const exists = this.AssetPortfolioList.some(
        x => x.AssetPortfolioCode === control.value
      );
      return exists ? { assetPortfolioCodeNotUnique: true } : null;
    };
  }

  btnClick_onUpdateAssetPortfolio(id) {
    $('#ModalAssetPortfolio').modal('hide');
    this.isOnUpdateAssetPortfolio = true
    console.log("btnClick_onUpdateAssetPortfolio id = " + id);

    let index = this.AssetPortfolioList.findIndex(x => x.AssetPortfolioID == id);

    this.formAssetPortfolio.patchValue({
      AssetPortfolioName: this.AssetPortfolioList[index].AssetPortfolioName != null ? this.AssetPortfolioList[index].AssetPortfolioName : null,
      AssetPortfolioDesc: this.AssetPortfolioList[index].AssetPortfolioDesc != null ? this.AssetPortfolioList[index].AssetPortfolioDesc : null
    });

    this.hidAssetPortfolioID = this.AssetPortfolioList[index].AssetPortfolioID

    $('#ModalAssetPortfolio').modal();
  }

  async btnClick_submitInsertAssetPortfolio() {
    if (this.formAssetPortfolio.valid) {
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            console.log('form submitted');
            //this.OnCreating('y');
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
              })
            };
    
            var objectjson = {};
            objectjson['AssetPortfolioName'] = this.checkUndefinedString(this.formAssetPortfolio.get('AssetPortfolioName')?.value);
            objectjson['AssetPortfolioDesc'] = this.checkUndefinedString(this.formAssetPortfolio.get('AssetPortfolioDesc')?.value);
            objectjson['CreateBy'] = this.checkUndefinedString(this._EmpCode);
    
            let strjson = JSON.stringify(objectjson);
    
            this.isSubmitted = this.httpClient.post<AssetPortfolioInfo[]>(this.baseurl + "AssetType/InsertAssetPortfolio", strjson, httpOptions)
    
              .subscribe(result => this.isSubmitted = result, failCb => {
                console.log("Insert fail")
                //this.OnCreating('n');            
              },
                () => {
                  console.log("Insert = " + this.isSubmitted)
                  $('#ModalAssetPortfolio').modal('hide');
                  $('#ModalDeleteAssetTypeComplete').modal();
                  this.LoadAssetPortfolioList();
                }
              )
          }
    
        } else {
          this.validateAllFormFields(this.formAssetPortfolio);
        }
  }

  async btnClick_submitUpdateAssetPortfolio(id) {
    if (this.formAssetPortfolio.valid) {
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            //this.OnUpdating('y');
    
            id = this.hidAssetPortfolioID
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
    
              })
            };
    
            var objectjson = {};
            objectjson['AssetPortfolioID'] = id;
            objectjson['AssetPortfolioName'] = this.checkUndefinedString(this.formAssetPortfolio.get('AssetPortfolioName')?.value);
            objectjson['AssetPortfolioDesc'] = this.checkUndefinedString(this.formAssetPortfolio.get('AssetPortfolioDesc')?.value);
            objectjson['UpdateBy'] = this.checkUndefinedString(this._EmpCode);
    
            let strjson = JSON.stringify(objectjson);
    
            this.isSubmitted = this.httpClient.post<AssetPortfolioInfo[]>(this.baseurl + "AssetType/UpdateAssetPortfolio", strjson, httpOptions)
    
              .subscribe(result => this.isSubmitted = result, failCb => {
                console.log("Update fail");
                //this.OnUpdating('n');
              },
                () => {
                  console.log("Update = " + this.isSubmitted);
                  //this.OnUpdating('n');
                  $('#ModalAssetPortfolio').modal('hide');
                  $('#ModalCreateUpdateAssetPortfolioComplete').modal();
                  this.LoadAssetPortfolioList();
                }
              )
          }
        } else {
          this.validateAllFormFields(this.formAssetPortfolio);
        }
  }

  async btnClick_onDeleteAssetPortfolioList() {
    const checkedAssetPortfolio = $('[name="checkboxassetPortfolio"]:checked');
    const num = checkedAssetPortfolio.length;
    if (num === 0) {
      alert("กรุณาเลือกอย่างน้อย 1 รายการในการลบ");
    return;
  }

    if (confirm("ยืนยันว่าต้องการลบรายการ Asset Portfolio?")) {
    
          var checkkedassetportfolio = $('[name="checkboxassetPortfolio"]:checked');
          let num = checkkedassetportfolio.length;
          let listAssetPortfolioModel = []; // listAssetGroupModel
          
    
          for (var i = 0; i < num; i++) {
            var AssetPortfoliocurrent = <HTMLInputElement>checkkedassetportfolio[i];
            let AssetportfolioInfo = new AssetPortfolioInfo; // AssetgroupInfo // AssetGroupID
            AssetportfolioInfo.AssetPortfolioID = parseInt(AssetPortfoliocurrent.value);
    
              var currentPortfolioGroup = this.AssetPortfolioList.filter(x => { return x.AssetPortfolioID == AssetportfolioInfo.AssetPortfolioID });
              var isOwner = (currentPortfolioGroup[0].CreateBy == this._EmpCode);
    
              console.log(" Delete id = " + AssetportfolioInfo.AssetPortfolioID + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
              if (isOwner || (this._RoleCode != "")) {
                listAssetPortfolioModel.push(AssetportfolioInfo);
              } else
              {
                //this.titlemodal = ""
                //this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
                this.detailmodal = "You don't have permission to delete this asset port folio. Please contact" + currentPortfolioGroup[0].CreateBy;
                $('#ModalError .modal-header').text("Information");
                $('#ModalError .modal-header').addClass('bg-blue');
                $('#ModalError').modal();
    
                listAssetPortfolioModel = [];
                break; //break loop
              }
          }
    
          if (listAssetPortfolioModel.length > 0) {
            this.deleteListAssetPortfolio(listAssetPortfolioModel)
          }
    
        }
  }

  async deleteListAssetPortfolio(listAssetPortfolioModel) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        //Send to delete
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
       
  
        let strjsonCompPortfolioInfo = JSON.stringify(listAssetPortfolioModel);
  
        this.httpClient.post<AssetPortfolioInfo[]>(this.baseurl + "AssetType/DeleteListAssetPortfolio", strjsonCompPortfolioInfo, httpOptions)
          .toPromise()
          .then(data => {
            console.log("delete asset portfolio list successfully");
            $('#ModalDeleteComplete').modal('show');
            this.LoadAssetPortfolioList();
          })
          .catch(err => {
            console.log(err);
          });
      }
  }

  chkallAssetPortfolioclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxassetPortfolio"]').prop('checked', check);
  }

  async btnClick_viewAssetinPortfolio(AssetPortfolioCode: string, AssetPortfolioName: string) {   
     // Show asset category section
    this.AssetPortfolioCodeSelected = AssetPortfolioCode;
    this.AssetPortfolioNameSelected = AssetPortfolioName;

    const viewfromassetportfolio = "Y";

    this.isAssetGroupVisible = true;
    await this.loadAssetGroup(viewfromassetportfolio, AssetPortfolioCode);
  }
}
